import { productDetailsPath } from "../../../AppModules/AgriInput/utils/agriInputNavigation";
import { faqDetailsPath } from "../faq/faqNavigation";

export const navigateSearchResult = (item, { navigate, openExternal, onUnavailable } = {}) => {
  const { route, arguments: args } = item || {};

  // Videos hits: `route` is a full YouTube URL. Route it through the shared
  // external-link interstitial (useUrlDialog → UrlDialog) instead of a raw
  // window.open, matching the Footer / News-section outbound-link flow.
  if (typeof route === "string" && /^https?:\/\//i.test(route)) {
    openExternal?.(route);
    return;
  }

  // A video hit (carries `videoId`) whose URL is missing or not a real link has
  // nothing to open — surface the "link unavailable" toast rather than silently
  // falling through to the home page.
  if (args?.videoId) {
    onUnavailable?.();
    return;
  }

  const isLoggedIn = localStorage.getItem("DfsWeb.isLoggedIn") === "true";
  const homePath = isLoggedIn ? `${window.contextPath}/home` : `${window.contextPath}/`;

  switch (route) {
    case "/scheme-details":
      // SchemeInfo reads `location.state.schemeId`; without mdmsId there is no
      // tangible target, so toast instead of navigating with an undefined key.
      if (!args?.mdmsId) {
        onUnavailable?.();
        return;
      }
      navigate(`${window.contextPath}/schemes/details`, { state: { schemeId: args.mdmsId } });
      return;

    case "/asset-details-screen":
      // AssetsDetailPage reads `location.state.id`; bail with a toast if absent.
      if (!args?.id) {
        onUnavailable?.();
        return;
      }
      navigate(`${window.contextPath}/assets-section/assets-details`, { state: { id: args.id } });
      return;

    case "/horti-service-details-screen":
      // Horti (Marketplace Services). Unlike scheme/asset (location.state), the horti detail page
      // reads the id from the QUERY STRING (useSearchParams) — so build a query param, not state.
      // No id ⇒ nothing to resolve ⇒ toast, matching the scheme/asset missing-target behaviour.
      if (!args?.id) {
        onUnavailable?.();
        return;
      }
      navigate(`${window.contextPath}/horti/provider-details?id=${encodeURIComponent(args.id)}`);
      return;

    case "/help-section-faq-details-screen":
      if (!args?.code) {
        onUnavailable?.();
        return;
      }
      navigate(faqDetailsPath(args.code), { state: { question: item?.title || "" } });
      return;

    case "/agri-marketplace/product":
      if (!args?.productId) {
        onUnavailable?.();
        return;
      }
      navigate(productDetailsPath(args.productId));
      return;

    default:
      // /agri-tips-details-screen (Advisory) lands here today — those rows are
      // already filtered out by useGlobalSearch, so this default only fires if
      // the backend adds a new shape we haven't taught the transformer about.
      navigate(homePath);
      return;
  }
};
